import { render, staticRenderFns } from "./setorandeposito.vue?vue&type=template&id=973e7e6c&scoped=true&"
import script from "./setorandeposito.vue?vue&type=script&lang=js&"
export * from "./setorandeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973e7e6c",
  null
  
)

export default component.exports